import { render } from "./customer-menu.vue?vue&type=template&id=205faaf8"
import script from "./customer-menu.vue?vue&type=script&lang=js"
export * from "./customer-menu.vue?vue&type=script&lang=js"
script.render = render

export default script